/**
 * 路由预加载 Hook
 * 智能预加载用户可能访问的页面资源
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { preloadPaddle } from '../services/paddlePreloader';
import { log } from '../utils/logger';

/**
 * 路由预加载 Hook
 */
export function useRoutePreloader() {
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;

    // 根据当前路径预加载相关资源
    const preloadForRoute = async () => {
      // 在首页时预加载 Paddle（用户很可能会访问定价页面）
      if (currentPath === '/') {
        log.debug('在首页预加载 Paddle SDK');
        preloadPaddle().catch(error => {
          log.warn('首页 Paddle 预加载失败', error);
        });
      }

      // 在功能页面时预加载 Paddle（用户可能会去定价页面）
      if (currentPath === '/features') {
        log.debug('在功能页面预加载 Paddle SDK');
        preloadPaddle().catch(error => {
          log.warn('功能页面 Paddle 预加载失败', error);
        });
      }

      // 在登录页面时预加载 Paddle（登录后可能会去定价页面）
      if (currentPath === '/login') {
        log.debug('在登录页面预加载 Paddle SDK');
        preloadPaddle().catch(error => {
          log.warn('登录页面 Paddle 预加载失败', error);
        });
      }
    };

    // 延迟执行，避免阻塞页面渲染
    const timer = setTimeout(preloadForRoute, 500);
    
    return () => clearTimeout(timer);
  }, [location.pathname]);
}

/**
 * 鼠标悬停预加载 Hook
 */
export function useHoverPreloader() {
  useEffect(() => {
    const handleMouseEnter = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const link = target.closest('a[href="/pricing"]');
      
      if (link) {
        log.debug('检测到定价页面链接悬停，预加载 Paddle SDK');
        preloadPaddle().catch(error => {
          log.warn('悬停预加载 Paddle 失败', error);
        });
      }
    };

    // 监听鼠标悬停事件
    document.addEventListener('mouseenter', handleMouseEnter, true);
    
    return () => {
      document.removeEventListener('mouseenter', handleMouseEnter, true);
    };
  }, []);
}

export default useRoutePreloader;